import { render, staticRenderFns } from "./historyTraffic.vue?vue&type=template&id=5d654a00&"
import script from "./historyTraffic.vue?vue&type=script&lang=js&"
export * from "./historyTraffic.vue?vue&type=script&lang=js&"
import style0 from "./historyTraffic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports